import { render, staticRenderFns } from "./EventSlotting.vue?vue&type=template&id=2968e0d0&scoped=true&"
import script from "./EventSlotting.vue?vue&type=script&lang=ts&"
export * from "./EventSlotting.vue?vue&type=script&lang=ts&"
import style0 from "./EventSlotting.vue?vue&type=style&index=0&id=2968e0d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2968e0d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTabItem } from 'vuetify/lib/components/VTabs';
installComponents(component, {VAlert,VBtn,VCardActions,VCardSubtitle,VCardText,VCardTitle,VExpansionPanels,VIcon,VTabItem})
